/**
 * Utility functions for handling base path configuration
 * This ensures all paths work correctly when the app is served under /account
 */

/**
 * Get the base path for the application
 * Defaults to '/account' but can be overridden via environment variable
 */
export const getBasePath = (): string => {
  // Use environment variable if set, otherwise default to /account
  return process.env.REACT_APP_BASE_PATH || '/account';
};

/**
 * Get a full path with the base path prefix
 * @param path - The path to prefix (should start with /)
 * @returns The full path with base path prefix
 */
export const getFullPath = (path: string): string => {
  const basePath = getBasePath();
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // Combine base path with normalized path
  return `${basePath}${normalizedPath}`;
};
